/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import MenuContainer from './MenuContainer';
import SearchSelect from '@/components/UI/SearchSelect';
import Button from '@/components/UI/Button';
import type { TanStackColumnDef } from '@/components/UI/Table/TableComponent.model';

interface ColumnWithVisibility<T = unknown> extends TanStackColumnDef<T> {
  isVisible?: boolean;
  lockVisibility?: boolean;
}

interface TableShowMenuProps<T = unknown> {
  columns: Array<ColumnWithVisibility<T>>;
  handleChange: (columns: Array<ColumnWithVisibility<T>>) => void;
  closeMenu?: () => void;
}

const TableShowMenu = ({ columns, handleChange, closeMenu }: TableShowMenuProps) => {
  const selected = columns.reduce<Array<string>>((acc, column) => {
    if (column.isVisible && !column.lockVisibility) {
      acc.push(column.id as string);
    }
    return acc;
  }, []);

  return (
    <MenuContainer width={300}>
      <SearchSelect
        sections={[
          {
            title: 'All fields',
            items: columns
              .filter((column) => column.header)
              .map((column) => ({
                id: column.id as string,
                title: typeof column.header === 'string' ? column.header : (column.id as string),
              })),
          },
        ]}
        overflowHeight={300}
        selected={selected}
        setSelected={(selected: Array<string>) =>
          handleChange(
            columns.map((column) => ({
              ...column,
              isVisible: column.lockVisibility ? column.isVisible : selected.includes(column.id as string),
            }))
          )
        }
      />
      <div className="bt b--moon-gray pa3">
        <Button onClick={closeMenu} plain className="f6 w-100">
          Close
        </Button>
      </div>
    </MenuContainer>
  );
};

export default TableShowMenu;
